import React from "react";
import "../style/general-surgery.css";
import Servicessidebar from "../components/servicessidebar";


const points = [
    "Hernia and Piles Clinic",
    "Varicose Veins Clinic"
];

const Generalsurgery = () => {
    return (
        <div className="general-section">
            <div className="container">
                <div className="general-surg-je">

                    <div className="general-jp">
                        <h2 className="general-title">GENERAL SURGERY</h2>

                        <p className="general-description">
                            Even in today’s modern age of specialization, General Surgery is an important and inevitable service
                            required by a large number of patients. To cater to this essential need, SAL hospital has built a
                            formidable department of General Surgery equipped with the latest infrastructure. Our patient-centred
                            approach to care is designed to maximize the quality of life, ensuring that the unique physical,
                            psychological and social needs of each patient are met.
                        </p>

                        <p className="general-description">
                            The Department of General Surgery caters to a wide range of surgical ailments and emergencies. From the
                            treatment of Minor Swellings to Complex Abdominal Surgeries, SAL’s highly skilled team of Surgeons, Nurses
                            and Technicians leave no stone unturned in ensuring every patient receives nothing but the best of our
                            treatment and services.
                        </p>

                        <p className="general-description">
                            Most of the Abdominal Surgeries performed at SAL are Laparoscopy or Keyhole Surgeries, which are done
                            within world-class operation theatres equipped with advanced tools and techniques. Many of these operations
                            are day-care procedures.
                        </p>

                        <ul className="general-list">
                            {points.map((item, index) => (
                                <li key={index} className="general-item">
                                    <span className={`general-icon ${index % 2 === 0 ? "blue" : "green"}`}>
                                        {index % 2 === 0 ? "➤" : "✔"}
                                    </span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="general-surg-side">
                        <Servicessidebar />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Generalsurgery;
